
export default {
  name: 'logo',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    withoutText: {
      type: Boolean,
      default: false,
    },
  },
};
